import { Component, Input } from '@angular/core';
import { cn } from '../../../../utils/utils';

interface ISimpleStepStep {
  stepName: string;
  stepNumber: number;
}

/** Index-driven step header (CSV phone upload, smart broadcast). */
@Component({
  selector: 'app-simple-stepper',
  standalone: true,
  imports: [],
  templateUrl: './simple-stepper.component.html',
  styleUrls: ['./simple-stepper.component.css', '../stepper/stepper-track.css'],
})
export class SimpleStepperComponent {
  constructor() {}
  merge = cn;

  @Input({ required: true }) steps: ISimpleStepStep[] = [];
  @Input() currentIndex: number = 0;
  @Input() noContent: boolean = false;
  @Input() contentClass: string = '';
  @Input() headerClass: string = '';

  stateOf(index: number): 'done' | 'current' | 'todo' {
    if (index < this.currentIndex) return 'done';
    return index === this.currentIndex ? 'current' : 'todo';
  }
}
